import {FC} from 'react';
import {TableCell, TableRow} from '@mui/material';

import styles from './TableEmptyState.module.scss';

interface Props {
  /** Основной текст. По умолчанию — нейтральное «ничего не найдено». */
  title?: string;
  /** Подсказка под текстом: что можно сделать. */
  hint?: string;
}

const EmptyBoxIcon = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M8 20.5L28 10L48 20.5V38L28 48L8 38V20.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M8 20.5L28 30L48 20.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path d="M28 30V48" stroke="currentColor" strokeWidth="2" />
  </svg>
);

/** Сам блок «пусто» — можно использовать и вне таблицы. */
export const EmptyState: FC<Props> = ({
  title = 'Nothing here yet',
  hint = 'Try changing the filters or the search query',
}) => (
  <div className={styles.wrapper}>
    <span className={styles.icon}>
      <EmptyBoxIcon />
    </span>
    <span className={styles.title}>{title}</span>
    {hint ? <span className={styles.hint}>{hint}</span> : null}
  </div>
);

/**
 * Заглушка для пустой таблицы.
 * colSpan заведомо больше числа колонок — так ячейка растягивается на всю
 * ширину в любой таблице и не нужно считать колонки на каждой странице.
 */
const TableEmptyState: FC<Props> = (props) => (
  <TableRow>
    <TableCell colSpan={100} sx={{borderBottom: 0, padding: 0}}>
      <EmptyState {...props} />
    </TableCell>
  </TableRow>
);

export default TableEmptyState;
